export default function TariffPreviewTable({ preview }) {
  if (!preview) {
    return (
      <section className="card tariff-import-card">
        <h2>3. Vorschau</h2>
        <div className="empty-state">Noch keine Datei analysiert.</div>
      </section>
    );
  }

  return (
    <section className="card tariff-import-card">
      <div className="section-head">
        <div>
          <h2>3. Erkannte Tabellen</h2>
          <p className="section-text">Alle erkannten Werte muessen vor dem Aktivieren geprueft werden.</p>
        </div>
      </div>

      {preview.messages?.map((message) => (
        <div key={message} className="message message-info tariff-import-message">
          {message}
        </div>
      ))}

      {preview.tables?.length ? (
        preview.tables.map((table) => (
          <div key={table.name} className="tariff-preview-block">
            <h3>{table.name}</h3>
            <div className="table-wrap">
              <table className="data-table tariff-preview-table">
                <thead>
                  <tr>
                    {(table.headers || []).map((header) => (
                      <th key={header}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(table.rows || []).slice(0, 30).map((row, rowIndex) => (
                    <tr key={`${table.name}-${rowIndex}`}>
                      {(table.headers || []).map((header) => (
                        <td key={header}>{String(row[header] ?? "")}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))
      ) : (
        <div className="empty-state">Keine strukturierte Tabelle erkannt. Werte koennen manuell erfasst werden.</div>
      )}
    </section>
  );
}
